import React, {FC} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import axios from 'axios';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';

interface PrintheadProps {
  name: string;
  placeholder?: string;
  example?: string;
  pattern?: string;
}

const Printhead: FC<PrintheadProps> = ({
  name,
  placeholder,
  example = 'ABC1234',
  pattern = '^[A-Z]{3}[0-9]+$',
}) => {
  const {control, trigger, getValues} = useFormContext();

  const validateSerial = async (value: string) => {
    if (value.length !== 7) return 'Serial must be 7 characters';

    const printHeads = getValues(`print_heads.${getValues('printer_type')}`) || [];
    if (printHeads.filter((ph) => ph?.serial?.toUpperCase() === value.toUpperCase()).length > 1) {
      return 'This serial already exists in the list!';
    }

    try {
      const url = process.env.REACT_APP_APIURL + 'printhead/checkduplicate';
      const authToken = authHeader();
      const formData = new FormData();
      formData.append('serial', value);

      const response = await axios.post(url, formData, {headers: authToken});

      if (response.status === 201) {
        return true;
      }
    } catch (err) {
      if (err.response?.status === 409) {
        return 'This serial number already exists!';
      }
      return 'Error checking serial';
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: 'Serial is required',
        pattern: {
          value: new RegExp(pattern),
          message: 'Invalid serial format',
        },
        minLength: {value: 7, message: 'Serial must be 7 characters'},
        maxLength: {value: 7, message: 'Serial must be 7 characters'},
        validate: validateSerial,
      }}
      render={({field, fieldState}) => (
        <div>
          <input
            {...field}
            type="text"
            className="form-control"
            placeholder={placeholder}
            maxLength={7}
            value={field.value?.toUpperCase() || ''}
            onChange={async (e) => {
              const val = e.target.value.toUpperCase();
              field.onChange(val);
              await trigger(field.name);
            }}
          />
          <small className="text-muted">Example: {example}</small>
          {fieldState.error && <div className="text-danger"><small>{fieldState.error.message}</small></div>}
        </div>
      )}
    />
  );
};

export default Printhead;
